import { useMutation } from '@apollo/client';

import { DeleteClientContactInput } from '__generated__/GQL';
import { logEvent } from 'features/Analytics/analytics';

import { refetchGetClient } from '../useGetClient';
import { DeleteClientContactDocument } from './graphql/deleteClientContact.gql';

const useDeleteClientContact = (clientId: string) => {
  const [mutation, result] = useMutation(DeleteClientContactDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [refetchGetClient(clientId)],
  });

  const deleteClientContact = (
    clientContactId: DeleteClientContactInput['clientContactId'],
  ) => {
    logEvent({
      name: 'Client Contact Deleted',
      properties: { clientContactId, clientId },
      usePrefix: false,
    });
    return mutation({ variables: { input: { clientContactId, clientId } } });
  };

  return { deleteClientContact, ...result };
};

export default useDeleteClientContact;
